/*require('./../../../style/input-plugin/shortcut.less');*/
var $ = require('jQuery');
var template = require('./../../../template/chatwindow-header-plugin/feedback.html');
var Plugin = require('./Plugin');

var Feedback = function (options) {
    this._opened = false;

    (function (self) {
        var defaults = {
            template: template,
            texts: []
        };
        $.extend(defaults, options);
        Plugin.call(self, defaults);

        self._element.find('.im-feedback-icon').click(function () {
            if (self._opened) {
                self.close();
            } else {
                self.open();
                // 根据接口判断对方是否已经被屏蔽
                if (self._element.find('.im-feedback-texts')[0].innerText.indexOf('屏蔽') !== -1) {
                    self._cwheader.isBlackedCheck();
                }
            }
        });

        self._element.on('click', function(e){
          e.stopPropagation();
        });

        var eleTextList = self._element.find('.im-feedback-texts');
        $(defaults.texts).each(function (index, item) {
            $('<li class="texts-icon texts-icon-' + index + '"><span class="texts-icon texts-icon-' + index + '"></span><span class="im-feedback-text">' + item + '</span></li>').appendTo(eleTextList);
        });
        eleTextList.click(function (e) {
            self.close();
            if ($.contains(eleTextList[0], $(e.target)[0])) {
                // 屏蔽功能
                var showText = e.target.tagName === 'LI' ? $(e.target).find('.im-feedback-text').text() : $(e.target).parent().find('.im-feedback-text').text();
                if (showText === '屏蔽') {
                    self._cwheader.addBlackList();
                    //埋点统计（屏蔽点击）
                    if(window.WMDA_REPORT){
                        window.WMDA_REPORT('custom',{event_id:'23'})
                    }
                } else if (showText === '取消屏蔽') {
                    self._cwheader.delBlackList();
                    //埋点统计（取消屏蔽点击）
                    if(window.WMDA_REPORT){
                        window.WMDA_REPORT('custom',{event_id:'24'})
                    }
                } else if (showText === '举报') {
                    self._cwheader.complaints();
                    //埋点统计（举报点击）
                    if(window.WMDA_REPORT){
                        window.WMDA_REPORT('custom',{event_id:'25'})
                    }
                } else if (showText === '删除并退出') {
                    self._cwheader.quitGroup();
                } else if (showText === '群二维码') {
                    self._cwheader.getGroupQrCode();
                } else if (showText === '群公告') {
                    self._cwheader.groupNotice();
                } else if (showText === '置顶') {
                    self._cwheader.sesTop(true);
                    //埋点统计（置顶点击）
                    if(window.WMDA_REPORT){
                        window.WMDA_REPORT('custom',{event_id:'19'})
                    }
                } else if (showText === '取消置顶') {
                    self._cwheader.sesTop(false);
                    //埋点统计（取消置顶点击）
                    if(window.WMDA_REPORT){
                        window.WMDA_REPORT('custom',{event_id:'20'})
                    }
                } else if (showText === '免打扰') {
                    self._cwheader.setSilent(true);
                    //埋点统计（免打扰点击）
                    if(window.WMDA_REPORT){
                        window.WMDA_REPORT('custom',{event_id:'21'})
                    }
                } else if (showText === '取消免打扰') {
                    self._cwheader.setSilent(false);
                    //埋点统计（取消免打扰点击）
                    if(window.WMDA_REPORT){
                        window.WMDA_REPORT('custom',{event_id:'22'})
                    }
                } else if (showText === '群设置'){
                    self._cwheader.setGroup(true);
                } else if (showText === '备注') {
                    self._cwheader.setUserRemark ()
                }
            }
        });

        $(self._win).click(function (e) {
            if (self._opened && !$.contains(self._element[0], e.target))
                self.close();
        });
    })(this);
};
Feedback.prototype = Object.create(Plugin.prototype);

module.exports = Feedback;
